import React from 'react';
import EdsChip from '@ellucian/react-design-system/core/es/Chip';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    root: {
        '& > span': {
            whiteSpace: 'inherit'
        },
        height: 'auto',
        minHeight: Tokens.sizingLarge,
        whiteSpace: 'initial',
        wordBreak: 'normal'
    }
});
const Chip = (props) => (React.createElement(EdsChip, Object.assign({}, props)));
export default withStyles(styles)(Chip);
